import { motion } from 'framer-motion'
import { Loader2 } from 'lucide-react'
import { feedbackAnimations, transitions } from '@/utils/animations'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  text?: string
}

const sizeMap = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8'
}

export function LoadingSpinner({ size = 'md', className = '', text }: LoadingSpinnerProps) {
  return (
    <div className={`flex items-center justify-center space-x-2 ${className}`}>
      <motion.div
        variants={feedbackAnimations.spinner}
        animate="animate"
      >
        <Loader2 className={sizeMap[size]} />
      </motion.div>
      {text && <span className="text-sm text-muted-foreground">{text}</span>}
    </div>
  )
}

export function PageLoading() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={transitions.normal}
      className="flex items-center justify-center min-h-[400px]"
    >
      <LoadingSpinner size="lg" text="Loading..." />
    </motion.div>
  )
}
